<template>
  <div class="inline-loader">
    <div class="block"></div>
  </div>
</template>

<script>
export default {
  name: 'InlineLoader',
};
</script>

<style lang="scss" scoped>
.inline-loader {
  width: 100%;
  height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .block {
    width: 40px;
    height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      content: '';
      margin-top: 40px;
      display: block;
      background-color: var(--color-blue);
      border-radius: 50%;
      animation-name: inline_loader;
      animation-duration: 0.8s;
      animation-iteration-count: infinite;
      animation-direction: normal;
      animation-timing-function: linear;
    }
  }
}
@keyframes inline_loader {
  from {
    width: 0;
    height: 0;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  80% {
    opacity: 0.5;
  }
  to {
    width: 40px;
    height: 40px;
    opacity: 0;
  }
}
</style>
